import {
  NoActiveThreadStateController,
  type NoActiveThreadStateProps,
} from "./NoActiveThreadStateController";

export type { NoActiveThreadStateProps };

export function NoActiveThreadState(props: NoActiveThreadStateProps = {}) {
  return <NoActiveThreadStateController {...props} />;
}
